import React, { useContext, useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import styles from "./Custom.module.css";
import { REDIRECT_FOR_CUSTOM, CLOTHING_CUSTOM_FIT_SCAN, SESSION_STORAGE_KEY, PARAMS_PROP } from "../../vars";
import { createCustomUrl, getParamsValue, setSessionStorage } from "../../utils/util";
import LoadingScreen from "../../components/loadingScreen/LoadingScreen";
import { getSwanService } from "../../service/swanService";
import { UserDetailsContext } from "../../context/userDetails";
import Home from "../home/Home";

function Custom() {
	const { id } = useParams();
	const [loading, setLoading] = useState(true);
	const { setScanType, setShopDomain, setMobileUrl, setShopifyRedirectUrl } = useContext(UserDetailsContext);

	const getCustomConfig = async () => {
		try {
			const res = await getSwanService().custom.getCustomCustomerConfig(id);
			console.log(res);

			if (res?.data?.hasCustomAddon) {
				const redirectUrl = getParamsValue("redirect_url");
				const obj = {
					storeUrl: res?.data?.customerStoreUrl ?? id,
					// storeName: id,
					shopifyRedirectUrl: redirectUrl,
					email: getParamsValue(PARAMS_PROP.EMAIL),
					name: getParamsValue(PARAMS_PROP.NAME),
					gender: getParamsValue(PARAMS_PROP.GENDER),
					// productName: getParamsValue(PARAMS_PROP.PRODUCT_NAME),
					callbackUrl: getParamsValue(PARAMS_PROP.CALLBACK_URL),
					source: getParamsValue(PARAMS_PROP.SOURCE),
				};
				if (redirectUrl) {
					setShopifyRedirectUrl(redirectUrl);
					setSessionStorage(SESSION_STORAGE_KEY.SHOPIFY_REDIRECT_URL, redirectUrl);
				}
				// setStoreName(id);
				setSessionStorage(SESSION_STORAGE_KEY.STORE_NAME, id);
				setScanType(CLOTHING_CUSTOM_FIT_SCAN);
				setSessionStorage(SESSION_STORAGE_KEY.SCAN_TYPE, CLOTHING_CUSTOM_FIT_SCAN);
				setShopDomain(res?.data?.customerStoreUrl);
				setSessionStorage(SESSION_STORAGE_KEY.SHOP_DOMAIN, res?.data?.customerStoreUrl);
				setMobileUrl(createCustomUrl(obj));
				localStorage.clear();
			} else {
				window.location.href = REDIRECT_FOR_CUSTOM;
			}
		} catch (err) {
			console.log(err);
			window.location.href = REDIRECT_FOR_CUSTOM;
		} finally {
			setTimeout(() => {
				setLoading(false);
			}, 1000);
		}
	};
	useEffect(() => {
		if (id) {
			getCustomConfig();
		}
	}, [id]);
	return (
		<>
			{" "}
			<div className={styles.imageWithButton}>{loading ? <LoadingScreen size={60} className="h-full w-full   flex alignCenter justifyCenter" /> : <Home />}</div>{" "}
		</>
	);
}

export default Custom;
